module.exports = __webpack_public_path__ + "images/notifications-b4ad42e691c3f9646477f21b0ce98014.svg";